module.exports = __webpack_public_path__ + "img/533.62cdc72c.png";